import React from "react";
import {
  CompactDateInput,
  FieldWrapper,
  FilterMultiSelect,
  formatGroupedValues,
} from "./jobsFilterUtils";

export function AccountingClientReportsFilterFields({
  focusedFieldId,
  onFocusClear,
  filterDate,
  setFilterDate,
  filterClientIds = [],
  setFilterClientIds,
  weekFilterClients = [],
}) {
  const clientOptions = weekFilterClients.map((c) => ({
    value: String(c.id),
    label: String(c.name),
  }));

  return (
    <>
      <FieldWrapper
        fieldId="date"
        label="Date"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <CompactDateInput
          id="accounting-clientreports-date"
          value={filterDate}
          onChange={setFilterDate}
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="client"
        label="Client"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterMultiSelect
          id="accounting-clientreports-client"
          options={clientOptions}
          value={filterClientIds.map(String)}
          onChange={(vals) => setFilterClientIds(vals.map(Number))}
          placeholder="Select Client..."
        />
      </FieldWrapper>
    </>
  );
}

export function buildAccountingClientReportsFilterChips({
  searchTerm,
  filterDate,
  filterClientIds = [],
  weekFilterClients = [],
}) {
  const chips = [];

  if (searchTerm) {
    chips.push({
      id: "search",
      key: "search",
      fieldId: "search",
      label: `Search: ${searchTerm}`,
    });
  }

  if (filterDate) {
    chips.push({
      id: "date",
      key: "date",
      fieldId: "date",
      label: `Date: ${filterDate}`,
    });
  }

  if (filterClientIds.length > 0) {
    const formatClient = (id) => {
      const match = weekFilterClients.find((c) => Number(c.id) === Number(id));
      return match?.name || `#${id}`;
    };
    chips.push({
      id: "client",
      key: "client",
      fieldId: "client",
      label: `Clients: ${formatGroupedValues(filterClientIds, formatClient, 3)}`,
    });
  }

  return chips;
}
